import defaults from './defaults';

export default {
  ...defaults,
  sentry: {
    ...defaults.sentry,
    enabled: true,
    environment: 'production',
  },
  urls: {
    ...defaults.urls,
  },
};
